/**
 * Tuijncode Invoice Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.tuijncodeInvoiceDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
